import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center field-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0150"),
  /*#__PURE__*/_createTextVNode(" Current Payment Sources for Home Care (mark all that apply) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "form-check pb-2 ms-2"
}
const _hoisted_5 = ["id", "value", "checked", "onChange"]
const _hoisted_6 = ["for"]
const _hoisted_7 = {
  key: 0,
  class: "d-flex mt-2 bg-white flex-column p-2 pb-4 ms-4 w-40"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "service-required-text-color" }, "Other Payment Source ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Payment Source",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: _normalizeClass(`${
                            _ctx.v$.referral.Demographics.PaymentSources.$error ||
                            _ctx.errors.Demographics.includes('PaymentSources')
                                ? 'border border-warning rounded p-2'
                                : ''
                        }`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentOptions, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${option.value}-${option.label}`
              }, [
                (_ctx.showOption(option))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: `${option.value}-${option.label}`,
                        value: option.value,
                        checked: _ctx.referral.Demographics.PaymentSources.includes(option.value),
                        onChange: ($event: any) => (_ctx.handlePaymentSource(option.value)),
                        onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.PaymentSources.$touch && _ctx.v$.referral.Demographics.PaymentSources.$touch(...args)))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `${option.value}-${option.label}`
                      }, [
                        _createElementVNode("small", null, _toDisplayString(option.label), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_6)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */),
          (_ctx.referral.Demographics.PaymentSources.includes('12'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control w-90",
                  placeholder: "Enter Payment Source",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.Demographics.OtherPaymentSource) = $event)),
                  maxlength: "300"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Demographics.OtherPaymentSource]
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}